import { put, takeLatest } from "redux-saga/effects";
import {
  requestInvoiceList,
  requestGetByIdInvoice,
  createInvoice,
  editInvoice,
  createInvoiceFromBills,
  editInvoiceStatus,
  invoiceStatusToGenerated,
  cancelInvoice,
  requestLastInvoiceAndCreditNoteList,
  createFinancialInvoice,
  requestInvoiceNoList,
  requestPendingEInvoiceList,
  requestOptimizedInvoiceList,
  requestInvoiceAndCreditNoteList
} from "services/acclgl/invoice";
import {
  fetchInvoiceListRequest,
  fetchInvoiceListSuccess,
  fetchInvoiceListFailure,
  fetchInvoiceListByIdRequest,
  fetchInvoiceListByIdSuccess,
  fetchInvoiceListByIdFailure,
  createInvoiceRequest,
  createInvoiceSuccess,
  createInvoiceFaliure,
  editInvoiceRequest,
  editInvoiceSuccess,
  editInvoiceFaliure,
  createInvoiceFromBillsRequest,
  createInvoiceFromBillsSuccess,
  createInvoiceFromBillsFaliure,
  editInvoiceStatusRequest,
  editInvoiceStatusSuccess,
  editInvoiceStatusFaliure,
  invoiceStatusToGeneratedRequest,
  invoiceStatusToGeneratedSuccess,
  invoiceStatusToGeneratedFailure,
  cancelInvoiceRequest,
  cancelInvoiceSuccess,
  cancelInvoiceFailure,
  fetchLastInvoiceAndCreditNoteListRequest,
  fetchInvoiceAndCreditNoteListRequest,
  fetchLastInvoiceAndCreditNoteListSuccess,
  fetchInvoiceAndCreditNoteListSuccess,
  fetchLastInvoiceAndCreditNoteListFailure,
  fetchInvoiceAndCreditNoteListFailure,
  createFinancialInvoiceRequest,
  createFinancialInvoiceSuccess,
  createFinancialInvoiceFaliure,
  fetchInvoiceNoRequest,
  fetchInvoiceNoSuccess,
  fetchInvoiceNoFailure,
  fetchGeneratePendingEInvoiceListRequest,
  fetchGeneratePendingEInvoiceListFailure,
  fetchGeneratePendingEInvoiceListSuccess,
  fetchRentalSupplementaryInvoiceListRequest,
  fetchRentalSupplementaryInvoiceListSuccess,
  fetchRentalSupplementaryInvoiceListFailure,
  fetchTransportInvoiceListRequest,
  fetchTransportInvoiceListSuccess,
  fetchTransportInvoiceListFailure,
  fetchDeliveryChallanInvoiceListRequest,
  fetchDeliveryChallanInvoiceListSuccess,
  fetchDeliveryChallanInvoiceListFailure,
  fetchFinalInvoiceListRequest,
  fetchFinalInvoiceListSuccess,
  fetchFinalInvoiceListFailure,
} from "redux/reducers/acclgl/invoice";
export function* watchInvoiceSaga() {
  yield takeLatest(fetchInvoiceListRequest, fetchInvoicelist);
  yield takeLatest(fetchInvoiceListByIdRequest, fetchInvoicelistById);
  yield takeLatest(createInvoiceRequest, createInvoiceService);
  yield takeLatest(editInvoiceRequest, editInvoiceService);
  yield takeLatest(createInvoiceFromBillsRequest, createInvoiceFromBillService);
  yield takeLatest(editInvoiceStatusRequest, editInvoicesStatusRequest);
  yield takeLatest(
    invoiceStatusToGeneratedRequest,
    invoiceStatusToGeneratedService
  );
  yield takeLatest(cancelInvoiceRequest, cancelInvoiceRequestSaga);
  yield takeLatest(
    fetchLastInvoiceAndCreditNoteListRequest,
    fetchLastInvoiceAndCreditNoteList
  );
  yield takeLatest(
    fetchInvoiceAndCreditNoteListRequest,
    fetchInvoiceAndCreditNoteList
  );
  yield takeLatest(
    createFinancialInvoiceRequest,
    createFinancialInvoiceService
  );
  yield takeLatest(fetchInvoiceNoRequest, fetchInvoiceNo);
  yield takeLatest(
    fetchGeneratePendingEInvoiceListRequest,
    fetchPendingEInvoiceList
  );
  yield takeLatest(
    fetchRentalSupplementaryInvoiceListRequest,
    fetchRentalSupplementaryInvoiceList
  );
  yield takeLatest(fetchTransportInvoiceListRequest, fetchTransportInvoiceList);
  yield takeLatest(
    fetchDeliveryChallanInvoiceListRequest,
    fetchDeliveryChallanInvoiceList
  );
  yield takeLatest(fetchFinalInvoiceListRequest, fetchFinalInvoicelist);
}

function* fetchInvoicelist({ payload }) {
  try {
    const response = yield requestInvoiceList(payload);
    yield put(fetchInvoiceListSuccess(response));
  } catch (error) {
    yield put(fetchInvoiceListFailure("Failed to get list of Invoice"));
  }
} //used this in payment for showing details against invoice

function* fetchInvoicelistById({ payload }) {
  try {
    const response = yield requestGetByIdInvoice(payload);
    yield put(fetchInvoiceListByIdSuccess(response));
  } catch (error) {
    yield put(fetchInvoiceListByIdFailure("Failed to get  Invoice"));
  }
}

function* createInvoiceService({ payload }) {
  try {
    const response = yield createInvoice(payload);
    yield put(createInvoiceSuccess(response.data));
  } catch (error) {
    yield put(createInvoiceFaliure("Failed to create Invoice"));
  }
}

function* editInvoiceService({ payload }) {
  try {
    const response = yield editInvoice(payload);
    yield put(editInvoiceSuccess(response.data));
  } catch (error) {
    yield put(editInvoiceFaliure("Failed to get update Invoice"));
  }
}

function* createInvoiceFromBillService({ payload }) {
  try {
    const response = yield createInvoiceFromBills(payload);
    yield put(createInvoiceFromBillsSuccess(response.data));
  } catch (error) {
    yield put(createInvoiceFromBillsFaliure("Failed to create Invoice"));
  }
}

function* editInvoicesStatusRequest({ payload }) {
  try {
    const response = yield editInvoiceStatus(payload);
    yield put(editInvoiceStatusSuccess(response));
  } catch (error) {
    yield put(
      editInvoiceStatusFaliure(
        "Failed to get update Invoice Entry In Tally Status"
      )
    );
  }
}

function* invoiceStatusToGeneratedService({ payload }) {
  try {
    const response = yield invoiceStatusToGenerated(payload);
    yield put(invoiceStatusToGeneratedSuccess(response.data));
  } catch (error) {
    yield put(
      invoiceStatusToGeneratedFailure("Failed to change Invoice status")
    );
  }
}

function* cancelInvoiceRequestSaga({ payload }) {
  try {
    const response = yield cancelInvoice(payload);
    yield put(cancelInvoiceSuccess(response));
  } catch (error) {
    yield put(cancelInvoiceFailure("Failed to cancel invoice"));
  }
}

function* fetchLastInvoiceAndCreditNoteList({ payload }) {
  try {
    const response = yield requestLastInvoiceAndCreditNoteList(payload);
    yield put(fetchLastInvoiceAndCreditNoteListSuccess(response));
  } catch (error) {
    yield put(
      fetchLastInvoiceAndCreditNoteListFailure(
        "Failed to get list of Last Invoice And CreditNote"
      )
    );
  }
}

function* createFinancialInvoiceService({ payload }) {
  try {
    const response = yield createFinancialInvoice(payload);
    yield put(createFinancialInvoiceSuccess(response.data));
  } catch (error) {
    yield put(
      createFinancialInvoiceFaliure("Failed to create Financial Invoice")
    );
  }
}

function* fetchInvoiceNo({ payload }) {
  try {
    const response = yield requestInvoiceNoList(payload);
    yield put(fetchInvoiceNoSuccess(response));
  } catch (error) {
    yield put(fetchInvoiceNoFailure("Failed to get Invoice No data"));
  }
}

function* fetchPendingEInvoiceList({ payload }) {
  try {
    const response = yield requestPendingEInvoiceList(payload);
    yield put(fetchGeneratePendingEInvoiceListSuccess(response));
  } catch (error) {
    yield put(
      fetchGeneratePendingEInvoiceListFailure("Failed to get Invoice data")
    );
  }
}

function* fetchRentalSupplementaryInvoiceList({ payload }) {
  try {
    const response = yield requestOptimizedInvoiceList(payload);
    yield put(fetchRentalSupplementaryInvoiceListSuccess(response));
  } catch (error) {
    yield put(
      fetchRentalSupplementaryInvoiceListFailure(
        "Failed to get Rental and Supplementary Invoice data"
      )
    );
  }
}

function* fetchTransportInvoiceList({ payload }) {
  try {
    const response = yield requestOptimizedInvoiceList(payload);
    yield put(fetchTransportInvoiceListSuccess(response));
  } catch (error) {
    yield put(
      fetchTransportInvoiceListFailure("Failed to get Transport Invoice data")
    );
  }
}

function* fetchDeliveryChallanInvoiceList({ payload }) {
  try {
    const response = yield requestOptimizedInvoiceList(payload);
    yield put(fetchDeliveryChallanInvoiceListSuccess(response));
  } catch (error) {
    yield put(
      fetchDeliveryChallanInvoiceListFailure(
        "Failed to get Delivery Challan Invoice data"
      )
    );
  }
}

function* fetchFinalInvoicelist({ payload }) {
  try {
    const response = yield requestOptimizedInvoiceList(payload);
    yield put(fetchFinalInvoiceListSuccess(response));
  } catch (error) {
    yield put(fetchFinalInvoiceListFailure("Failed to get list of Invoice"));
  }
}

function* fetchInvoiceAndCreditNoteList({ payload }) {
  try {
    const response = yield requestInvoiceAndCreditNoteList(payload);
    yield put(fetchInvoiceAndCreditNoteListSuccess(response));
  } catch (error) {
    yield put(
      fetchInvoiceAndCreditNoteListFailure(
        "Failed to get list of Last Invoice And CreditNote"
      )
    );
  }
}